export default __webpack_public_path__ + "static/media/emoji_neutral.02a50737.png";